var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0767 25.875H32.8267L29.4517 32.625L24.9517 19.125L21.5767 25.875H19.3267M27.1863 11.5556C22.6877 6.2964 15.1861 4.8817 9.54972 9.69753C3.91336 14.5134 3.11984 22.5652 7.54611 28.2609C10.8894 32.563 20.3871 41.1996 24.8347 45.1685C25.6523 45.8981 26.0611 46.2629 26.5398 46.4065C26.9553 46.5311 27.4172 46.5311 27.8327 46.4065C28.3114 46.2629 28.7202 45.8981 29.5378 45.1685C33.9854 41.1996 43.4831 32.563 46.8264 28.2609C51.2527 22.5652 50.556 14.4627 44.8228 9.69753C39.0895 4.93235 31.6848 6.2964 27.1863 11.5556Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthIcon);
export default __webpack_public_path__ + "static/media/healthIcon.36a32d2cabab8ffc9c75b0706a707954.svg";
export { ForwardRef as ReactComponent };